module.exports = __webpack_public_path__ + "static/img/creditcard.0cd30bc6.svg";